var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarSolid = function SvgCalendarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.25v2a.75.75 0 0 1-1.5 0V5h-6.5v2a.75.75 0 0 1-1.5 0V5Zm.25 8c-.167 0-.5.1-.5.5v1c0 .167.1.5.5.5h1c.167 0 .5-.1.5-.5v-1c0-.167-.1-.5-.5-.5h-1ZM7 17.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1Zm4.5-4.5c-.167 0-.5.1-.5.5v1c0 .167.1.5.5.5h1c.167 0 .5-.1.5-.5v-1c0-.167-.1-.5-.5-.5h-1Zm-.5 4.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1Zm4.5-4.5c-.167 0-.5.1-.5.5v1c0 .167.1.5.5.5h1c.167 0 .5-.1.5-.5v-1c0-.167-.1-.5-.5-.5h-1Zm-.5 4.5c0-.4.333-.5.5-.5h1c.4 0 .5.333.5.5v1c0 .4-.333.5-.5.5h-1c-.4 0-.5-.333-.5-.5v-1ZM5.5 9.25a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5h-13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3v2M8 3v2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCalendarSolid;